import React from "react";

const SidebarFooter = () => {
  return <div className="siderbar_footer"></div>;
};

export default SidebarFooter;
